import { getApiUrl } from "@Helpers/api/buildUrl";

/**
 * Gets a checkout session from the backend so we could open a paddle request.
 */
export async function getPaymentMethodCheckoutSessionApi(subscription) {
  const url = getApiUrl("settings/payment-method");
  const params = {
    subscription: subscription.id || subscription.name,
    subscription_type: subscription.type,
    billing_type: subscription.billing_type,
  };
  const response = await axios.get(url, { params });

  return response.data;
}
